import { c as _c } from "react/compiler-runtime";
import { useRef } from 'react';
import { styled, alpha, useTheme } from '@classify/react-core-components/styles';
import Typography from '@classify/react-core-components/Typography';
import { ReactNode } from 'react';
import { ChapterType } from '../_types';
const FooterRoot = styled('footer')(({
  theme: {
    palette
  }
}) => ({
  display: 'flex',
  padding: 0,
  width: '100%',
  backgroundColor: palette.background.paper
}));
const LabelWrapper = styled('div')(({
  theme: {
    spacing
  }
}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  width: '100%',
  height: '100%',
  borderTop: '1px solid',
  marginLeft: 'auto',
  padding: spacing(3, 5)
}));
const CourseLabel = styled(Typography)(({
  theme: {
    spacing,
    palette,
    breakpoints
  }
}) => ({
  display: 'none',
  [breakpoints.up('sm')]: {
    display: 'block',
    color: palette.text.primary,
    textAlign: 'right',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    maxWidth: '60ch',
    marginTop: spacing(1),
    whiteSpace: 'nowrap'
  }
}));
export interface Props {
  categoryColor?: string;
  children: ReactNode;
  nextChapter: ChapterType | null;
}
const CourseNavigationFooter = t0 => {
  const $ = _c(13);
  const {
    categoryColor,
    children,
    nextChapter
  } = t0;
  const footerRef = useRef(null);
  const theme = useTheme();
  const effectiveCategoryColor = categoryColor || (theme.palette as any).brand?.main || theme.palette.primary.main;
  let t1;
  if ($[0] !== effectiveCategoryColor) {
    t1 = alpha(effectiveCategoryColor, 0.08);
    $[0] = effectiveCategoryColor;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== effectiveCategoryColor) {
    t2 = alpha(effectiveCategoryColor, 0.32);
    $[2] = effectiveCategoryColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = {
      backgroundColor: t1,
      borderColor: t2
    };
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== nextChapter) {
    t4 = nextChapter ? <CourseLabel variant="subtitle2" component="p">{nextChapter.title}</CourseLabel> : null;
    $[7] = nextChapter;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== children || $[10] !== t3 || $[11] !== t4) {
    t5 = <FooterRoot ref={footerRef}><LabelWrapper style={t3}>{children}{t4}</LabelWrapper></FooterRoot>;
    $[9] = children;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
export default CourseNavigationFooter;